import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const mutation = gql`
  mutation UpdateOAuthSettings($businessId: String!, $provider: OAuthProvider!, $domains: [String]) {
    updateOAuthSettings(businessId: $businessId, provider: $provider, domains: $domains)
  }
`
export const updateOAuthSettingsKey = getQueryNames(mutation)[0]

export default mutation
